
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Expenditure_V1 = () => {
  const [kitchenId, setKitchenId] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setSelectedDate(today);
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
    }
  }, []);

  // alert(selectedDate)
  useEffect(() => {
    if (!kitchenId) return;

    const fetchStock = async () => {
      try {
        const response = await axios.get(
          `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${kitchenId}/`
        );
        const formatted = response.data.map((item) => ({
          id: item.item_id,
          itemName: `${item.stock_name} (${item.unit})`,
          availableStock: Math.abs(parseFloat(item.quantity)),
        }));
        setUsers(formatted);
        console.log(formatted);

      } catch (error) {
        console.error("Stock fetch error:", error);
      }
    };

    fetchStock();
  }, [kitchenId]);

  const handleAddItem = () => {
    const selected = users.find((item) => item.id === parseInt(selectedItemId));
    const qty = parseFloat(quantity);

    if (!selectedItemId || isNaN(qty) || qty <= 0) {
      alert("Please select a valid item and quantity.");
      return;
    }

    if (qty > selected.availableStock) {
      alert("Quantity exceeds available stock.");
      return;
    }

    const alreadyAdded = selectedItems.find(
      (item) => item.kitchestock === parseInt(selectedItemId)
    );
    if (alreadyAdded) {
      alert("This item is already added.");
      return;
    }

    const newItem = {
      kitchestock: selected.id,
      itemName: selected.itemName,
      expenditure_quantity: qty,
      remarks: remarks || "",
      kitchen_id: kitchenId,
      add_date: selectedDate,
      availableStock: selected.availableStock,
      price: 0,
      amount: 0,
    };

    setSelectedItems([...selectedItems, newItem]);
    setSelectedItemId("");
    setQuantity("");
    setRemarks("");
  };

  const handleSubmitAll = async () => {
    if (selectedItems.length === 0) {
      alert("Please add at least one item.");
      return;
    }

    setIsSaving(true);
    try {
      const payload = selectedItems.map(({ itemName, availableStock, ...rest }) => rest);
      await axios.post(
        "https://ims-backend.indevconsultancy.in/api/daily-expenditures/",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      // alert("All items submitted successfully!");
      navigate("/ExpenditureListKitchen");
    } catch (err) {
      console.error("Submission error:", err);
      alert("Failed to submit.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0 text-white">Daily Expenditure Entry</h5>
        </div>
        <div className="card-body">
          {/* Date and Item Selector */}
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold"> Date</label>
              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>

            <div className="col-md-8">
              <label className="form-label fw-semibold"> Select Item</label>
              <select
                className="form-select"
                value={selectedItemId}
                onChange={(e) => setSelectedItemId(e.target.value)}
              >
                <option value="">Select Item</option>
                {users.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.itemName} &nbsp; | &nbsp; Available: {item.availableStock}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Quantity & Remarks */}
          {selectedItemId && (
            <div className="row mt-3 g-3">
              <div className="col-md-4">
                <label className="form-label fw-semibold"> Quantity</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  placeholder="Enter quantity"
                  value={quantity}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
              <div className="col-md-8">
                <label className="form-label fw-semibold"> Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter remarks (optional)"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
            </div>
          )}

          {/* Add Button */}
          <div className="text-end mt-3">
            <button className="btn btn-info" onClick={handleAddItem}>
              Add Item to List
            </button>
          </div>

          {/* Display Table */}
          {selectedItems.length > 0 && (
            <>
              <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Available</th>
                      <th>Used</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItems.map((item, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{item.itemName}</td>
                        <td><span className="badge bg-secondary">{item.availableStock}</span></td>
                        <td>{item.expenditure_quantity}</td>
                        <td>{item.remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-end">
                <button
                  className="btn btn-success mt-3"
                  onClick={handleSubmitAll}
                  disabled={isSaving}
                >
                  {isSaving ? "Submitting..." : "Submit All"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Expenditure_V1;